function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 0H0V60H89.999V0Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 7.49902H0V14.9983H89.999V7.49902Z",
  fill: "#D80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 22.4995H0V29.9988H89.999V22.4995Z",
  fill: "#D80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 37.498H0V44.9973H89.999V37.498Z",
  fill: "#D80027"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 52.4985H0V59.9978H89.999V52.4985Z",
  fill: "#D80027"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9995 0H0V32.3077H44.9995V0Z",
  fill: "#2E52B2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5465 13.2349L16.8217 15.4644H14.4775L16.3744 16.8417L15.6496 19.0711L17.5465 17.6939L19.4421 19.0711L18.7175 16.8417L20.6143 15.4644H18.27L17.5465 13.2349Z",
  fill: "#F0F0F0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.27 23.5107L17.5465 21.2812L16.8217 23.5107H14.4775L16.3744 24.8881L15.6496 27.1175L17.5465 25.7401L19.4421 27.1175L18.7175 24.8881L20.6143 23.5107H18.27Z",
  fill: "#F0F0F0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M8.36293 23.5107L7.63924 21.2812L6.91451 23.5107H4.57031L6.46715 24.8881L5.74241 27.1175L7.63924 25.7401L9.53502 27.1175L8.81046 24.8881L10.7069 23.5107H8.36293Z",
  fill: "#F0F0F0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M7.63924 13.2349L6.91451 15.4644H4.57031L6.46715 16.8417L5.74241 19.0711L7.63924 17.6939L9.53502 19.0711L8.81046 16.8417L10.7069 15.4644H8.36293L7.63924 13.2349Z",
  fill: "#F0F0F0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5465 5.18896L16.8217 7.41873H14.4775L16.3744 8.79613L15.6496 11.0255L17.5465 9.64814L19.4421 11.0255L18.7175 8.79613L20.6143 7.41873H18.27L17.5465 5.18896Z",
  fill: "#F0F0F0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M7.63924 5.18896L6.91451 7.41873H4.57031L6.46715 8.79613L5.74241 11.0255L7.63924 9.64814L9.53502 11.0255L8.81046 8.79613L10.7069 7.41873H8.36293L7.63924 5.18896Z",
  fill: "#F0F0F0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.454 13.2349L26.7294 15.4644H24.3853L26.2819 16.8417L25.5575 19.0711L27.454 17.6939L29.35 19.0711L28.6252 16.8417L30.5221 15.4644H28.1779L27.454 13.2349Z",
  fill: "#F0F0F0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1779 23.5107L27.454 21.2812L26.7294 23.5107H24.3853L26.2819 24.8881L25.5575 27.1175L27.454 25.7401L29.35 27.1175L28.6252 24.8881L30.5221 23.5107H28.1779Z",
  fill: "#F0F0F0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0849 23.5107L37.3612 21.2812L36.6365 23.5107H34.2925L36.189 24.8881L35.4644 27.1175L37.3612 25.7401L39.257 27.1175L38.5323 24.8881L40.4291 23.5107H38.0849Z",
  fill: "#F0F0F0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M37.3612 13.2349L36.6365 15.4644H34.2925L36.189 16.8417L35.4644 19.0711L37.3612 17.6939L39.257 19.0711L38.5323 16.8417L40.4291 15.4644H38.0849L37.3612 13.2349Z",
  fill: "#F0F0F0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M27.454 5.18896L26.7294 7.41873H24.3853L26.2819 8.79613L25.5575 11.0255L27.454 9.64814L29.35 11.0255L28.6252 8.79613L30.5221 7.41873H28.1779L27.454 5.18896Z",
  fill: "#F0F0F0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M37.3612 5.18896L36.6365 7.41873H34.2925L36.189 8.79613L35.4644 11.0255L37.3612 9.64814L39.257 11.0255L38.5323 8.79613L40.4291 7.41873H38.0849L37.3612 5.18896Z",
  fill: "#F0F0F0"
});

var SvgUsd = function SvgUsd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/USD.d911f562.svg";
export { ForwardRef as ReactComponent };